import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import getBlockedExternalContentInfoBarViewStates from 'owa-calendar-forms-common/lib/utils/infobar/getBlockedExternalContentInfoBarViewStates';
import { InfoBarMessageSource, InfoBarMessageViewState } from 'owa-info-bar';

/**
 * Returns all the infoBars applicable for Peek
 * @param event - The subject event
 */
const getInfoBarMessageViewStates = (event: CalendarEvent): InfoBarMessageViewState[] => [
    ...getBlockedExternalContentInfoBarViewStates(event, InfoBarMessageSource.Peek),
];

export default getInfoBarMessageViewStates;
